export default __webpack_public_path__ + "static/media/misc-makeupA-768w.7f63393a.png";